app.controller("SendQuestionnaireController", ["$scope", "StaticData", "QuestionnairesService", "ProgramService", "Selection", "Lecturer", "$stateParams", "$uibModal", "Students", "Subject", "Users", "$state", "ConfirmModal", "usSpinnerService", "toastr",
    function ($scope, StaticData, QuestionnairesService, ProgramService, Selection, Lecturer, $stateParams, $uibModal, Students, Subject, Users, $state, ConfirmModal, usSpinnerService, toastr) {
        $scope.panelTitle = 'კითხვარის გაგზავნა';
        $scope.buttonText = 'გაგზავნა';
        $scope.questionnaire = null;
        $scope.isMandatory = false;

        $scope.range = [
            { 'name': 1, 'val': false },
            { 'name': 2, 'val': false },
            { 'name': 3, 'val': false },
            { 'name': 4, 'val': false },
            { 'name': 5, 'val': false },
            { 'name': 6, 'val': false },
            { 'name': 7, 'val': false },
            { 'name': 8, 'val': false },
            { 'name': 9, 'val': false },
            { 'name': 10, 'val': false },
        ];

        $scope.activeSeasonsVariants = [
            { key: 'intersection', name: 'ისწავლა ყველა სეზონში' },
            { key: 'union', name: 'ისწავლა ერთი სეზონში მაინც' },
        ];

        $scope.filterType = "selection";
        $scope.semester = 'სემესტრი';
        $scope.semesters = ['სემესტრი'].concat(_.range(1, 15));
        $scope.faculty = null;
        $scope.level = null;
        $scope.totalStudents = 0;
        $scope.totalSelections = 0;
        $scope.selectedSubjects = [];
        $scope.activeSeasons = [];
        $scope.activeSeasonsVariant = 'intersection';
        $scope.subject = null;
        $scope.subjects = [{ 'name': 'საგანი' }];
        $scope.season = null;
        $scope.popup1 = {
            opened: false
        };
        $scope.popup2 = {
            opened: false
        };
        $scope.popup3 = {
            opened: false
        };

        $scope.popup4 = {
            opened: false
        };

        $scope.popup5 = {
            opened: false
        };

        $scope.openFromDate = function () {
            $scope.popup1.opened = true;
        };

        $scope.openToDate = function () {
            $scope.popup2.opened = true;
        };

        $scope.openMandatoryDate = function () {
            $scope.popup3.opened = true;
        };

        $scope.openActiveFromDate = function () {
            $scope.popup4.opened = true;
        };

        $scope.openActiveToDate = function () {
            $scope.popup5.opened = true;
        };

        var now = new Date();
        $scope.years = _.range(2017, now.getFullYear() + 1);
        $scope.activeTimeFrom = new Date(2019, 0, 0, 0, 0);
        $scope.activeTimeTo = new Date(2019, 0, 0, 0, 0);

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{ name: "საფეხური" }].concat(levels);
        });

        StaticData.getItemsByKey("gender").then(function (gender) {
            $scope.genders = [{ name: "სქესი" }].concat(gender);
        });

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.states = [{ name: "სტატუსი" }].concat(states);
        });

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{ name: "ფაკულტეტი" }].concat(faculties);
        });

        StaticData.getItemsByKey("subject_seasons").then(function (seasons) {
            $scope.seasons = [].concat(seasons);
            $scope.seasonsMap = _.keyBy($scope.seasons, '_id');

            $scope.filterSeasons = [{ 'name': 'წელი/სეზონი' }];
            $scope.years.forEach(function (year) {
                $scope.seasons.forEach(function (season) {
                    $scope.filterSeasons.push({
                        _id: year + '-' + season._id,
                        name: year + ' ' + season.name
                    })
                })
            })
            $scope.filterSeasonsMap = _.keyBy($scope.filterSeasons, '_id');
        });

        StaticData.getItemsByKey("lecturer_states").then(function (activeStates) {
            $scope.lecturerStates = [{ name: "სტატუსი" }].concat(activeStates);
        });

        StaticData.getItemsByKey("session_types").then(function (types) {
            $scope.sessionTypes = [{ name: "სესიის ტიპი" }].concat(types);
            $scope.sessionTypesMap = _.keyBy($scope.sessionTypes, '_id');
        });

        $scope.$watch('program', function (val) {
            if (!val || val && val._id) $scope.changeFilter();
        }, true);

        $scope.$watch('subject', function (val) {
            if (!val || val && val._id) $scope.changeFilter();
        }, true);

        QuestionnairesService.getTemplateById($stateParams.questionnaireId).then(function (result) {
            $scope.questionnaire = result;
            $scope.questionnaire.finishLimit = {
                value: 0,
                type: "AMOUNT"
            };
            if (!$scope.questionnaire.activeDateFrom) $scope.questionnaire.activeDateFrom = new Date();
            $scope.questionnaire.priority = 0;
        });

        $scope.add = function (subject) {
            $scope.selectedSubjects.push(subject);
            $scope.subject = null;
            $scope.getStudents();
        };

        $scope.remove = function (subject) {
            var index = $scope.selectedSubjects.indexOf(subject);
            $scope.selectedSubjects.splice(index, 1)
            $scope.getStudents();
        };

        $scope.changeSeason = function () {
            $scope.selectedSubjects = [];
            if ($scope.filterType === 'selection' || $scope.filterType === 'student') $scope.getStudents();
            if ($scope.filterType === 'lecturer' && $scope.level) {
                $scope.searchLecturers();
                $scope.getStudents();
            }
        };

        $scope.changeFilter = function () {
            if ($scope.filterType === 'lecturer' && $scope.level && $scope.filterSeason) {
                $scope.searchLecturers();
            } else if ($scope.filterType === 'lecturer' && (!$scope.level || !$scope.filterSeason)) {
                $scope.lecturers = [];
            } else {
                $scope.getStudents();
            }
        }

        $scope.addSeason = function (season) {
            var index = $scope.activeSeasons.indexOf(season);
            if (index >= 0) return;
            $scope.activeSeasons.push(season);
            $scope.activeSeason = null;
            $scope.getStudents();
        };

        $scope.removeSeason = function (season) {
            var index = $scope.activeSeasons.indexOf(season);
            $scope.activeSeasons.splice(index, 1)
            $scope.getStudents();
        };

        $scope.changeMandatory = function () {
            if ($scope.isMandatory) {
                $scope.questionnaire.mandatoryDate = new Date();
            } else {
                $scope.questionnaire.mandatoryDate = null;
            }
        }

        $scope.getStudents = function () {
            if ($scope.filterType === 'selection') {
                var subjectsArr = $scope.selectedSubjects.map(function (subject) {
                    return subject._id;
                });

                if ($scope.filterSeason) {
                    usSpinnerService.spin("root");
                    Students.receiversList({
                        level: $scope.level,
                        program: $scope.program ? $scope.program._id : undefined,
                        state: $scope.state,
                        selectedSubjects: subjectsArr,
                        season: $scope.filterSeason
                    }).then(function (data) {
                        $scope.totalStudents = data.receivers;
                        $scope.totalSelections = data.selections;
                        usSpinnerService.stop("root");
                    });
                }
            } else if ($scope.filterType === 'lecturer' && $scope.lecturers.length) {
                usSpinnerService.spin("root");
                var lecturerIds = $scope.lecturers.map((l) => {
                    return l._id
                })
                QuestionnairesService.getReceiversListForLecturer({
                    season: $scope.filterSeason,
                    level: $scope.level,
                    faculty: $scope.faculty,
                    subject: $scope.subject ? $scope.subject._id : null,
                    program: $scope.program ? $scope.program._id : undefined,
                    sessionType: $scope.sessionType,
                    lecturers: lecturerIds
                }).then(function (data) {
                    $scope.totalStudents = data.receivers;
                    $scope.totalSelections = data.selections;
                    usSpinnerService.stop("root");
                });
            } else if ($scope.filterType === 'student' || $scope.filterType === 'activeSeason') {
                usSpinnerService.spin("root");
                Students.list({
                    query: '',
                    faculty: $scope.faculty,
                    level: $scope.level,
                    state: $scope.state,
                    semester: $scope.semester !== 'სემესტრი' ? $scope.semester : undefined,
                    program: $scope.program ? $scope.program._id : undefined,
                    gender: $scope.gender,
                    activeSeasons: $scope.activeSeasons,
                    activeSeasonsVariant: $scope.activeSeasonsVariant,
                }).then(function (data) {
                    $scope.totalStudents = data.total;
                    $scope.totalSelections = data.total;
                    usSpinnerService.stop("root");
                });
            }
        };

        $scope.getLecturers = function () {
            Lecturer.list({
                page: 1,
                query: '',
                limit: 10,
                faculty: $scope.faculty,
                activeState: $scope.lecturerState
            }).then(function (data) {
                $scope.totalLecturers = data.total;
            });
        };

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            return ProgramService.list({ query: name }).then(function (data) {
                return data.docs;
            });
        };

        $scope.getActivations = function (query) {
            if (query.length < 1) {
                return [];
            }
            return Selection.list({ season: $scope.filterSeason, query: query }).then(function (data) {

                $scope.subjects = data.docs.map(function (activation) {
                    return activation.subject;
                });

                return $scope.subjects;
            })
        };

        $scope.searchLecturers = function () {
            if ($scope.filterSeason && $scope.level) {
                Lecturer.listForQuestionnaire({
                    level: $scope.level,
                    season: $scope.filterSeason,
                    program: $scope.program,
                    faculty: $scope.faculty,
                    subject: $scope.subject ? $scope.subject._id : null,
                    sessionType: $scope.sessionType
                }).then(function (data) {
                    $scope.totalLecturers = data.length;
                    $scope.lecturers = data;
                    $scope.getStudents();
                });
            } else {
                toastr.warning('', 'გთხოვთ მიუთითოთ სასწავლო სეზონი და საფეხური');
            }
        };

        $scope.removeLecturer = function (lecturer) {
            var index = $scope.lecturers.indexOf(lecturer);
            $scope.lecturers.splice(index, 1)
        };

        $scope.changeFilterType = function (newType) {
            $scope.filterType = newType;
            if (newType === 'selection' || newType === 'student') {
                $scope.getStudents();
            }
            $scope.clean();
        };

        $scope.send = function () {
            usSpinnerService.spin("root");
            // $scope.questionnaire.activeDateFrom.setHours($scope.activeTimeFrom.getHours());
            // $scope.questionnaire.activeDateFrom.setMinutes($scope.activeTimeFrom.getMinutes());
            // $scope.questionnaire.activeDateTo.setHours($scope.activeTimeTo.getHours());
            // $scope.questionnaire.activeDateTo.setMinutes($scope.activeTimeTo.getMinutes());
            var lecturerIds = [];

            if ($scope.filterType == 'lecturer') {
                lecturerIds = $scope.lecturers.map((l) => {
                    return l._id
                })
            }
            $scope.questionnaire.filter = {
                type: $scope.filterType,
                level: $scope.level,
                faculty: $scope.faculty,
                program: $scope.program ? $scope.program._id : undefined,
                state: $scope.state,
                semester: parseInt($scope.semester),
                gender: $scope.gender,
                season: $scope.filterSeason,
                selectedSubjects: $scope.selectedSubjects,
                activeSeasons: $scope.activeSeasons,
                activeSeasonsVariant: $scope.activeSeasonsVariant,
                lecturers: lecturerIds,
                subject: $scope.subject ? $scope.subject._id : null,
            };
            var counts = {
                questionnaire: $scope.totalSelections,
                profile: $scope.totalStudents
            }

            QuestionnairesService.send($scope.questionnaire, counts).then(function () {
                usSpinnerService.stop("root");
                toastr.success('', 'კითხვარი გაგზავნილია');
                $state.go('admin.questionnaires.list')
            }, function () {
                usSpinnerService.stop("root");
                toastr.error('', 'დაფიქსირდა შეცდომა');
            });
        };

        $scope.clean = function () {
            $scope.filterSeason = null;
            $scope.program = null;
            $scope.level = null;
            $scope.faculty = null;
            $scope.gender = null;
            $scope.semester = 'სემესტრი';
            $scope.state = 'active';
            $scope.selectedSubjects = [];
            $scope.totalSelections = null;
            $scope.totalStudents = null;
            $scope.totalLecturers = null;
            $scope.lecturers = [];
        };
    }
]);
